import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getLeavesCancelRequest: ["children_id", "page"],
  getLeavesCancelSuccess: ["listLeavesCancel"],
  getLeavesCancelFailure: null,
});

export const GetLeavesCancelTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  payload: null,
  success: null,
  error: null,
  children_id: null,
  page: null,
});

export const GetLeavesCancelSelectors = {
  getData: (state: any) => state.getLeavesCancel.data,
  isFetching: (state: any) => state.getLeavesCancel.fetching,
  isSuccess: (state: any) => state.getLeavesCancel.success,
  hasError: (state: any) => state.getLeavesCancel.error,
};

export const request = (state: any, { children_id, page }: any) => {
  const updateData = {
    fetching: true,
    success: null,
    error: null,
    children_id,
    payload: null,
    page,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { listLeavesCancel } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    listLeavesCancel,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_LEAVES_CANCEL_REQUEST]: request,
  [Types.GET_LEAVES_CANCEL_SUCCESS]: success,
  [Types.GET_LEAVES_CANCEL_FAILURE]: failure,
});
